import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SessionService } from 'src/app/services/session.service';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';
import { UserPreference } from 'src/app/models/AccountModel';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit {

  public openSplashScreen = false;

  constructor(private _dialogReference: MatDialogRef<SplashScreenComponent>, private _sessionService: SessionService, public themeManager: ThemeManagerService) {
    const pref = _sessionService.getCurrentUser().getPreference('ui.showSplashScreen');
    if (pref) {
      this.openSplashScreen = _sessionService.getCurrentUser().getPreference('ui.showSplashScreen').getBooleanValue();
    }
  }

  ngOnInit(): void {

  }

  onEvent(event) {
    if (event.state == 'CLOSECLICKED') {
      this._dialogReference.close();
    }
  }

  openUrl(url) {
    window.open(url, '_blank');
  }

  setSplashPreference() {
    this._sessionService.setCurrentUserPreference('ui.showSplashScreen', this.openSplashScreen ? 'true' : 'false');
  }
}
